import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './i18n';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import { preloadPublicNavItems, preloadPublicProgrammes, preloadPublicSlides, preloadPublicHomepageStats } from './services/siteContentService';
import App from './App';

import { seedProgramHeroCache, bootstrapProgramHeroCache } from './config/programHeroImages';
import { bootstrapProgramProjetsCache } from './config/programProjetsCache';
import { prefetchPriorityProgramHeroes, prefetchProgramProjets } from './utils/prefetchProgramHero';
import { getCachedFirstSlideImage, getCachedFirstSlidePreload } from './config/slidesCache';
import { preloadPublicSiteSettings } from './hooks/useSiteSettings';
import { preloadImage, injectDocumentPreload, normalizeStorageUrl } from './config/apiBase';
import hero1 from './assets/images/hero/hero-1.jpg';

bootstrapProgramHeroCache();
bootstrapProgramProjetsCache();

const cachedPreload = getCachedFirstSlidePreload();
const firstSlideImage = cachedPreload?.href || getCachedFirstSlideImage() || hero1;
injectDocumentPreload(firstSlideImage, {
  imageSrcSet: cachedPreload?.imageSrcSet,
  imageSizes: cachedPreload?.imageSizes,
});
void preloadImage(firstSlideImage);
preloadPublicSiteSettings();
preloadPublicNavItems();
preloadPublicHomepageStats();
preloadPublicSlides().then((data) => {
  if (!Array.isArray(data) || !data[0]) return;
  const url = normalizeStorageUrl(data[0].image_url_webp || data[0].image_url);
  if (url && url !== firstSlideImage) {
    const sm = normalizeStorageUrl(data[0].image_url_webp_sm);
    const desktop = normalizeStorageUrl(data[0].image_url_webp);
    injectDocumentPreload(url, {
      imageSrcSet: sm && desktop ? `${sm} 960w, ${desktop} 1600w` : undefined,
      imageSizes: sm && desktop ? '100vw' : undefined,
    });
    void preloadImage(url);
  }
});
preloadPublicProgrammes().then((data) => {
  if (!Array.isArray(data)) return;
  seedProgramHeroCache(data);
  const prefetchHeroes = () => prefetchPriorityProgramHeroes(data);
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(prefetchHeroes, { timeout: 600 });
  } else {
    window.setTimeout(prefetchHeroes, 150);
  }
});

const enablePageBackground = () => {
  document.body.classList.add('has-page-bg');
  void prefetchProgramProjets('saqya');
  void prefetchProgramProjets('omra');
  if (!document.getElementById('font-amiri')) {
    const link = document.createElement('link');
    link.id = 'font-amiri';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Amiri:wght@400;700&display=swap';
    document.head.appendChild(link);
  }
};

if (typeof window.requestIdleCallback === 'function') {
  window.requestIdleCallback(enablePageBackground, { timeout: 2500 });
} else {
  window.setTimeout(enablePageBackground, 1500);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
